import { createContext, useContext, useState } from 'react';
import type { Registration } from '@services/registrations';

interface RegistrationsContextType {
  registrations: Registration[];
  setRegistrations: (registrations: Registration[]) => void;
}

export const RegistrationsContext = createContext(
  {} as RegistrationsContextType
);

export function RegistrationsContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [registrations, setRegistrations] = useState<Registration[]>([]);

  return (
    <RegistrationsContext.Provider value={{ registrations, setRegistrations }}>
      {children}
    </RegistrationsContext.Provider>
  );
}

export function useRegistrationsContext(): RegistrationsContextType {
  const context = useContext(RegistrationsContext);
  if (context === undefined) {
    throw new Error(
      'useEventsContext must be used within an EventsContextProvider'
    );
  }
  return context;
}
